// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { OrganizationService_abstract } from './../abstract/SagaSchema/OrganizationService_abstract';
export class OrganizationService extends OrganizationService_abstract {}
